<template>
  <div>
    <el-input
      v-model="temp_value"
      :style="{
        width: width,
      }"
      class="input-item"
      placeholder="请输入"
    />
    <span style="margin-left: 10px">数量：{{ inputValue.length }}/{{ maxCount }}</span>
    <el-button type="primary" class="fr" @click="addInput">添加</el-button>
    <el-card v-if="inputValue.length" style="max-height: 300px;overflow: auto;">
      <div
        v-for="(item, index) in inputValue"
        :key="index"
        class="input-item"
      >
        <el-input
          v-model="inputValue[index]"
          :style="{
            width: width,
          }"
          placeholder="请输入"
          disabled
        />

        <i
          class="el-icon-remove input-list-icon"
          style="color: red"
          @click="removeInput(index)"
        />
      </div>
    </el-card>

  </div>
</template>

<script>
export default {
  props: {
    /** 值 */
    inputValue: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /** 输入框宽度 */
    width: {
      type: String,
      default: '500px',
    },
    /** 最大数量 */
    maxCount: {
      type: Number,
      default: 10,
    },
    /** 最小长度 */
    min: {
      type: Number,
      default: 1,
    },
    /** 最大长度 */
    max: {
      type: Number,
      default: 100,
    },
  },
  data(){
    return {
      temp_value: '',
    };
  },
  created() {
  },
  methods: {
    // 添加输入框
    addInput() {
      if (this.temp_value) {
        if (this.getStrLen(this.temp_value) < this.min || this.getStrLen(this.temp_value) > this.max) {
          this.$message.warning(`字数限制：[${this.min}-${this.max}]`);
        } else if (this.inputValue.length < this.maxCount) {
          this.inputValue.push(this.temp_value);
          this.temp_value = '';
        } else {
          this.$message.warning(`上限为${this.maxCount}个`);
        }
      } else {
        this.$message.warning('输入框不能为空');
      }
    },

    /**
     * 移除输入框
     * @param {number} index 索引值
     */
    removeInput(index) {
      if (this.inputValue.length !== 0) {
        this.inputValue.splice(index, 1);
      } else {
        this.$message.warning('至少保留一个');
      }
    },
    // 获取字符长度
    getStrLen(str) {
      var realLength = 0,
        len = str.length,
        charCode = -1;
      for (var i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128) {
          realLength += 1;
        } else {
          realLength += 2;
        }
      }
      return Math.ceil(realLength / 2);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-item {
    padding-bottom: 10px;
}
.input-list-icon {
    margin-left: 10px;
    font-size: 20px;
    vertical-align: middle;
    cursor: pointer;
    float: right;
}

</style>
